var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.00006V8.66673M2.91927 10.1333C2.31298 11.1834 2.00992 11.7086 2.05521 12.1395C2.09471 12.5153 2.29195 12.8567 2.59766 13.0788C2.94802 13.3334 3.55394 13.3334 4.76569 13.3334H11.2343C12.4461 13.3334 13.0519 13.3334 13.4023 13.0788C13.708 12.8567 13.9053 12.5153 13.9448 12.1395C13.9901 11.7086 13.6871 11.1834 13.0808 10.1333L9.84766 4.53326C9.24137 3.48314 8.93809 2.95817 8.54232 2.78196C8.19711 2.62826 7.80267 2.62826 7.45746 2.78196C7.06185 2.9581 6.75876 3.48307 6.15298 4.53232L2.91927 10.1333ZM8.03385 10.6667V10.7334L7.9668 10.7335V10.6667H8.03385Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconWhite);
export default __webpack_public_path__ + "static/media/warning-icon-white.ea3474a85819042a462bc93d0e22484f.svg";
export { ForwardRef as ReactComponent };